import React, { Component } from 'react';
import styled from 'styled-components';
import * as variables from '../../styles/variables';

const ReadOnlyText = styled.input`
  height: 45px;
  padding: 0px 16px;
  border-radius: 22px;
  border: 1px solid #ccc;
  background-color: ${variables.colours.lightGrey};
  margin-bottom: 10px;
  width: 320px;
  appearance: none;

  &:focus {
    outline-width: 0;
  }
`

export default ReadOnlyText